const shared = {
    recipientEntityId: "18",
    matterType: { id: "17", description: "Straffesag" },
    billableAmount: 5000,
    feeDistributionMethodEnabled: true,
    appliedDateMatterLedgerEntries: new Date(),
    appliedDateTimeTrackingEntries: new Date(),
    totalBillableAmount: 7000,
    recalculatedTotalMatterLedgerEntries: 2000,
    previouslyInvoicedAmount: 4000,
    nonInvoicedTime: 120,
    invoicedTime: 120,
    allowFeeLargerThanEstimatedTime: true,
    useSettingsFromMatterType: true,
    approve: true,
    rejectPossible: true,
    approvalFlowSteps: [
        { approverUserId: "AA", approved: true, current: false, level: 1 },
        { approverUserId: "FG", approved: false, current: true, level: 1 },
        { approverUserId: "JVA", approved: false, current: false, level: 1 }
    ]
};
export const preparedInvoices = [
    {
        id: 1,
        companyId: 100,
        matterId: "1234",
        clientId: "42",
        clientName: "Anders And",
        invoiceRegarding: "Testamente",
        fee: 5000,
        feeStatement: "Vedr. testamente.",
        matterLedgerEntriesSelectionId: 1,
        feeDistributionMethodId: 1,
        amountLimit: 10000,
        totalMatterLedgerEntries: 10,
        exceededEstimate: 2000,
        invoiceLanguageCode: "da",
        ...shared
    }
];
